import React from "react";

import { Label, Select } from "clearsense-ui/components";
import convertToSelectOptions from "utils/convertToSelectOptions";

const Filters = ({ cdes, cdeFilters, setCdeFilters }) => (
  <div className="flex space-x-4 justify-evenly w-full items-center">
    <Label>Filters:</Label>
    <Select
      isClearable
      placeholder="Select a Critical Data Element"
      className="w-1/3"
      size="small"
      value={cdeFilters?.map(filter => ({ label: filter, value: filter }))}
      onChange={selected => setCdeFilters(selected ? [selected?.value] : [])}
      options={convertToSelectOptions(cdes, { isSort: true })}
    />
    <Select
      isClearable
      placeholder="Select a Context"
      className="w-1/3"
      size="small"
      options={convertToSelectOptions(["Enterprise"], { isSort: true })}
    />
  </div>
);

export default Filters;
